/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { getEventLayoutComponentsObject } from '../EventComponentsJSON/EventComponentsJSON';
import {
  getSaleType,
  getEventLayoutComponentsData
} from '../../../selectors/topShopperPageSelectors';
import styles from './index.pcss';
import DesktopMainHeader from '../components/mobile/TopShopperHeader/DesktopMainHeader';
import {
  getTopShopperGrand,
  getTopShopperHeader,
  getTopShopperSubHeader
} from '../../../selectors/featureFlagsSelector';

const cx = classNames.bind(styles);

interface EventLayoutProps {
  saleType: 'PRE_SALE' | 'ACTIVE_SALE' | 'POST_SALE';
  platform: 'website' | 'msite' | 'app';
  grandPriceBannerImagePath: string;
  ctaInterceptor: () => void;
  pushGaEvent: () => void;
  eventName: string | null;
  grandEvent: string | null;
  onTimerComplete: () => void;
  redirectPage: (prop: Record<string, unknown>) => void;
  showDialog: () => void;
  onClickHowToParticipate: () => void;
  componentsData: Record<string, unknown>;
  topShopperHeader: string;
  topShopperSubHeader: string;
}

interface WrapperProps {
  id: string;
  styles?: Record<string, unknown>;
  classes?: string;
}

interface EventComponentsProps {
  id: string;
  classes: [];
  componentProps: Record<string, unknown>;
  Component: FC;
  wrapper?: WrapperProps | undefined;
}

const mapStateToProps = (state: any): Record<string, unknown> => {
  return {
    saleType: getSaleType(state),
    componentsData: getEventLayoutComponentsData(state),
    topShopperHeader: getTopShopperHeader(state),
    topShopperSubHeader: getTopShopperSubHeader(state),
    topShopperGrand: getTopShopperGrand(state)
  };
};

const connector = connect(mapStateToProps);

const EventLayout = (props: EventLayoutProps): JSX.Element => {
  const { platform, ctaInterceptor, pushGaEvent, topShopperHeader, topShopperSubHeader } = props;

  const associatedEventComponents = getEventLayoutComponentsObject(props) || [];
  return (
    <>
      {platform === 'website' && (
        <DesktopMainHeader
          topShopperHeader={topShopperHeader}
          topShopperSubHeader={topShopperSubHeader}
        />
      )}
      <div
        id="event-layout"
        className={cx('event-layout', `${platform === 'website' ? 'desk-event-layout' : ''}`)}
      >
        {associatedEventComponents.map((obj: EventComponentsProps, i: number) => {
          const { id = '', classes = [], Component, componentProps = {}, wrapper = undefined } =
            obj || {};

          if (Component) {
            const { id: wrapperId = '', styles: wrapperStyles = {}, classes: wrapperClasses = '' } =
              wrapper || {};
            const Element = (
              <Component
                id={id}
                classes={classes}
                platform={platform}
                ctaInterceptor={ctaInterceptor}
                pushGaEvent={pushGaEvent}
                {...componentProps}
              />
            );

            return (
              <div
                key={id}
                id={wrapperId}
                style={wrapperStyles}
                className={cx('wrapper', wrapperClasses)}
              >
                {Element}
              </div>
            );
          }
          return null;
        })}
      </div>
    </>
  );
};

export default connector(EventLayout);
